export const initialPersonalInfoState = () => ({
  fetchPersonalInfoLoading: false,
  fetchPersonalInfoFailure: false,
  fetchPersonalInfoLoaded: false,
  getProductVariantsLoding: false,
  getProductVariantsFailure: false,
  getProductVariantsLoaded: false,
});
